import { makeStyles } from '@material-ui/core/styles';

const useHorizontalButtonStyles = makeStyles(
  (theme) => ({
    root: {
      padding: `${theme.spacing(1, 5)} !important`,
    },
  }),
  { name: 'HorizontalButton' },
);

export default useHorizontalButtonStyles;
